import React from "react";
import { motion } from "framer-motion";

const ProgressBarExp = ({ step }) => {
  const totalSteps = 7;

  return (
    <div className="flex items-center justify-center w-full mt-6 select-none">

      {Array.from({ length: totalSteps }).map((_, index) => {
        const current = index + 1;
        const active = current <= step;

        return (
          <React.Fragment key={index}>

            {/* Bar */}
            <div
              className="h-[2px] rounded-sm overflow-hidden flex-shrink-0"
              style={{
                width: "55px",
                background: "rgba(255,255,255,0.15)",
              }}
            >
              <motion.div
                initial={{ width: 0 }}
                animate={{
                  width: active ? "100%" : "0%",
                  background: active
                    ? "linear-gradient(90deg, #fff700, #ffe44c)"
                    : "transparent",
                  boxShadow: active
                    ? "0 0 8px #fff700, 0 0 4px #ffd900"
                    : "none",
                }}
                transition={{ duration: 0.45, ease: "easeInOut" }}
                className="h-full"
              />
            </div>

            {/* Separator (skip last) */}
            {current < totalSteps && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{
                  opacity: active ? 1 : 0.4,
                  background: active ? "#fff700" : "#a5a5a5",
                  boxShadow: active
                    ? "0 0 5px #fff700, 0 0 3px #ffd900"
                    : "none",
                }}
                transition={{ duration: 0.35 }}
                className="w-[1px] h-[10px] mx-[2px] rounded-sm"
              />
            )}
          </React.Fragment>
        );
      })}

    </div>
  );
};

export default ProgressBarExp;
